import { createContext } from 'react';
export var PreviousPageContext = /*#__PURE__*/ createContext({
    previousPage: undefined
});
